import {Component, OnInit} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {FormFieldInstance} from '../model/FormFieldInstance';
import {FieldControl} from './FieldControl';
import {FormFieldType} from '../model/FormFieldType';
import {FieldTab} from '../model/FieldTab';

@Component({
  selector: 'lib-dff-tab-group',
  templateUrl: './dff-tab-group.component.html',
  styleUrls: ['./dff-tab-group.component.scss']
})
export class DffTabGroupComponent extends AbstractDynamicFormFieldDirective implements OnInit {

  FormFieldType = FormFieldType;
  activeTabId: string;

  ngOnInit() {
    this.activeTabId = this.field.tabs[0]?.id;
    const fieldTab = this.field.tabs[0];
    if (fieldTab) {
      fieldTab.isActive = true;
    }
  }

  validate(value: string): string[] {
    return [];
  }

  writeValue(value: string) {

  }

  onFieldInit(field: FormFieldInstance, viewRef: AbstractDynamicFormFieldDirective) {
    // @ts-ignore
    const fieldControl = field.__fieldControl as FieldControl;
    if (!fieldControl) { return; }
    fieldControl.viewRef = viewRef;
    // @ts-ignore
    delete field.__fieldControl;
  }

  getId(index: number, field: FormFieldInstance) {
    return field.fieldId;
  }

  activateTab(tab: FieldTab) {
    this.field.tabs.forEach(x => x.isActive = false);
    this.activeTabId = tab.id;
    tab.isActive = true;
  }
}
